import { useAppSelector } from '../app/hooks';
import { 
    getCreateInterviewStatus, 
    getInterviewAnalysisStatus, 
    getInterviews, 
    getInterviewFindingsData
} from '../features/analysis/logic/InterviewAnalysisSlice'

export const useInterviewFindings = () => {

    const interviewAnalysisStatus = useAppSelector(getInterviewAnalysisStatus);
    const interviews = useAppSelector(getInterviews);
    const createInterviewStatus = useAppSelector(getCreateInterviewStatus);
    const interviewsData = useAppSelector(getInterviewFindingsData)

    return {
        interviewAnalysisStatus,
        interviews,
        createInterviewStatus,
        interviewsData
    };
};